import React from "react";
import { mainTable } from "../css/Common";

const PopUpButtons = ({
  deleteDetails,

  cancelButtonHide,   // ✅ ADD THIS
  submitDetails,
  blockDetails,
  unBlockDetails,
  disabledBtn,
  cancelBtn,
  rowIndex,
  handleSubmit,
  handleUpload,
  uploadDetails,
  userDeactivateDetails,
  userActivateDetails,
  cancel,
  buttonLabel = "",
  flag,
  hederDetails,
}) => {
  return (
    <div className={mainTable.submitCancelMainDiv}>
      {deleteDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 3)}
          disabled={disabledBtn}
        >
          Delete
        </button>
      )}
      {submitDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 3)}
          disabled={disabledBtn}
        >
          {buttonLabel === "" ? "Submit" : buttonLabel}
        </button>
      )}
      {hederDetails && flag !== 1 && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, flag)}
          disabled={disabledBtn}
        >
          {flag === 2 ? "Update" : flag === 3 ? "Delete" : "Submit"}
        </button>
      )}

      {blockDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 4)}
          disabled={disabledBtn}
        >
          Make Inactive
        </button>
      )}
      {unBlockDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 5)}
          disabled={disabledBtn}
        >
          Make Active
        </button>
      )}
      {uploadDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleUpload(rowIndex, 6)}
          disabled={disabledBtn}
        >
          Submit
        </button>
      )}
      {userDeactivateDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 7)}
          disabled={disabledBtn}
        >
          Deactivate Login
        </button>
      )}
      {userActivateDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 8)}
          disabled={disabledBtn}
        >
          Activate Login
        </button>
      )}
      {/* {!cancelBtn &&(
<button
        data-modal-hide="bottom-right-modal"
        type="button"
        className={mainTable.cancelButton}
        onClick={() => cancel()}
      >
        CANCEL
      </button>
)} */}
      {!cancelBtn && !cancelButtonHide && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={mainTable.cancelButton}
          onClick={() => cancel()}
        >
          CANCEL
        </button>
      )}

    </div>
  );
};

export default PopUpButtons;
